import { FileText } from "lucide-react";
import { Card, CardContent } from "./ui/card";

export const MyLeadSheetzShelf = ({ sheets, onOpen }) => (
  <Card className="mb-6 border-primary/30 bg-gradient-to-r from-primary/10 to-primary/5" data-testid="my-lead-sheetz-shelf">
    <CardContent className="py-4">
      <div className="mb-3 flex items-center gap-2">
        <FileText className="h-5 w-5 text-primary" />
        <h3 className="font-serif font-semibold">My Lead Sheetz™</h3>
        <span className="text-xs text-muted-foreground">({sheets.length})</span>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1">
        {sheets.map((s) => (
          <button
            key={s.content_id}
            type="button"
            onClick={() => onOpen(s.content_id)}
            className="min-w-[180px] max-w-[220px] shrink-0 rounded-xl border border-primary/20 bg-background p-3 text-left transition-colors hover:border-primary hover:bg-primary/5"
            data-testid={`my-lead-sheet-${s.content_id}`}
          >
            <p className="truncate text-sm font-semibold">{s.title}</p>
            <p className="truncate text-xs text-muted-foreground">{s.course_name}</p>
          </button>
        ))}
      </div>
    </CardContent>
  </Card>
);
